<template>
  <b-card no-header no-footer>
    <ValidationObserver ref="form">
      <form @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12" md="6">
            <template
              v-for="(m, index) in filterModel([
                'school_name',
                'kepsek',
                'npsn',
                'bendahara',
                'total_student',
                'district_id',
                'village_id',
              ])"
            >
              <div :key="'informasi_sekolah_' + index">
                <form-group-input
                  :ref="index"
                  :type="m.type"
                  :label="typeof m.label === 'string' ? m.label : null"
                  :options="
                    m.type === 'radio'
                      ? getClassicOptions(index)
                      : getOptions(index)
                  "
                  :need-label="true"
                  v-model="m.value"
                  :rules="typeof m.rules !== 'undefined' ? m.rules : null"
                  :disabled="
                    typeof m.disabled !== 'undefined' ? m.disabled : null
                  "
                  :id="index"
                />
              </div>
            </template>
          </b-col>
          <b-col cols="12" md="6">
            <h5>Informasi Akun</h5>
            <template
              v-for="(m, index) in filterModel([
                'username',
                'name',
                'email',
                'password',
                'phone_number',
              ])"
            >
              <div :key="'informasi_akun_' + index">
                <form-group-input
                  :ref="'admin_' + index"
                  :type="m.type"
                  :label="typeof m.label === 'string' ? m.label : null"
                  :options="
                    m.type === 'radio'
                      ? getClassicOptions(index)
                      : getOptions(index)
                  "
                  :need-label="true"
                  v-model="m.value"
                  :rules="typeof m.rules !== 'undefined' ? m.rules : null"
                  :disabled="
                    typeof m.disabled !== 'undefined' ? m.disabled : null
                  "
                  :id="index"
                />
                <small
                  v-if="mode === 'update' && index === 'password'"
                  style="margin-top: -1rem !important; display: block"
                  class="mb-3"
                  >Kosongkan jika tidak ingin mengubah password.</small
                >
              </div>
            </template>
          </b-col>
        </b-row>
        <div>
          <b-button type="submit" variant="primary" class="mt-0"
            ><font-awesome-icon
              icon="spinner"
              spin
              v-if="isLoading"
            ></font-awesome-icon>
            Simpan</b-button
          >
          <b-button
            :to="'/sekolah'"
            variant="secondary"
            class="ml-3 float-right"
            ><font-awesome-icon
              icon="spinner"
              spin
              v-if="isLoading"
            ></font-awesome-icon>
            Batal</b-button
          >
        </div>
      </form>
    </ValidationObserver>
  </b-card>
</template>

<script>
import {
  saveProcess,
  setModelValue,
  scrollToError,
  objectToOptions,
  classicObjectToOptions,
} from "@/_helpers";
import formGroupInput from "@/components/FormGroupInput.vue";
import User from "@/models/User.js";
import City from "@/models/City.js";
import District from "@/models/District.js";
import Village from "@/models/Village.js";
import School from "@/models/School.js";

const schoolModel = new School();
const districtModel = new District();
const villageModel = new Village();

export default {
  components: {
    formGroupInput,
  },
  watch: {
    "$route.params.id": function (val) {
      if (this.mode === "update") {
        this.schoolModel.password.rules = null
        this.getDetail();
      }
    },
    "schoolModel.district_id.value": async function (val, oldVal) {
      if (val) {
        this.schoolModel.village_id.options = await this.getVillages(val);
        this.totalPromiseAreaCount++;
        if (val !== oldVal && !this.initEdit) {
          this.schoolModel.village_id.value = null;
        }
      } else {
        this.schoolModel.village_id.value = null;
      }
    },
    totalPromiseAreaCount: async function (val) {
      if (val >= 4) {
        this.initEdit = false;
      }
    },
  },
  computed: {
    mode: function () {
      return this.$route.params.id !== undefined ? "update" : "create";
    },
  },
  data() {
    return {
      totalPromiseAreaCount: 0,
      initEdit: false,
      isLoading: false,
      schoolModel: schoolModel.init(),
    };
  },
  mounted() {
    if (this.mode === "update") {
      this.schoolModel.password.rules = null
      this.getDetail();
    }

    this.getDistricts("950b9f62-d1c6-476b-a12d-9233fe332a75");
  },
  methods: {
    async getDistricts(cityId) {
      return new Promise((resolve) => {
        districtModel
          .list({
            city_id: cityId,
          })
          .then((resp) => {
            let data = [];
            resp.data.forEach((d) => {
              data[d.id] = d.name;
            });

            this.schoolModel.district_id.options = data;
          });
      });
    },
    async getVillages(districtId) {
      return new Promise((resolve) => {
        villageModel
          .list({
            district_id: districtId,
          })
          .then((resp) => {
            let data = [];
            resp.data.forEach((d) => {
              data[d.id] = d.name;
            });
            resolve(data);
          });
      });
    },
    filterModel(search) {
      const filtered = Object.entries(this.schoolModel).filter((mdl) => {
        return search.includes(mdl[0]);
      });
      let result = {};
      filtered.forEach((element) => {
        result[element[0]] = element[1];
      });
      return result;
    },
    getOptions(key) {
      return typeof this.schoolModel[key].options !== "undefined"
        ? objectToOptions(this.schoolModel[key].options)
        : null;
    },
    getClassicOptions(key) {
      return typeof this.schoolModel[key].options !== "undefined"
        ? classicObjectToOptions(this.schoolModel[key].options)
        : null;
    },
    getDetail() {
      this.initEdit = true;
      this.isLoading = true;
      schoolModel
        .find(this.$route.params.id, {
          detail: 1,
        })
        .then((resp) => {
          this.isLoading = false;
          Object.keys(this.schoolModel).forEach((key) => {
            if (typeof this.$refs[key] !== "undefined") {
              this.$refs[key][0].setValue(resp[key]);
            }else {
              key === 'password' ? this.$refs["admin_" + key][0].setValue('') : this.$refs["admin_" + key][0].setValue(resp['admin'][key])
            }
          });
          // let response = {};
          // Object.keys(resp.admin).forEach((key) => {
          //   if (!['name', 'email', 'phone_number', 'username', 'password'].includes(key)) {
          //     response[key] = resp.admin[key];
          //   }
          // });
          // Object.keys(resp.user_work_area).forEach((key) => {
          //   if (
          //     !["user_id", "village", "city", "district", "province"].includes(
          //       key
          //     )
          //   ) {
          //     response[key] = resp.user_work_area[key];
          //   }
          // });
          // Object.keys(resp).forEach((key) => {
          //   if (!["user_detail", "user_work_area"].includes(key)) {
          //     response[key] = resp[key];
          //   }
          // });
          // response["phone_number"] = response["phone_number"].replace(
          //   "+62",
          //   "0"
          // );
          // setModelValue(this.schoolModel, response);
        })
        .catch((error) => {
          if (process.env.NODE_ENV !== "production") {
            console.error(error);
          }
          this.isLoading = false;
        });
    },
    resetForm() {
      this.$nextTick(() => {
        // clearModelValue(this.schoolModel)
        Object.keys(this.schoolModel).forEach((key) => {
          this.$refs[key][0].setValue(null);
        });
        this.$refs.form.reset();
      });
    },
    onSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success || this.isLoading) {
          scrollToError(this.$refs.form);
          return false;
        }
        saveProcess(this.schoolModel, this.mode === "update")
          .then((model) => {
            this.isLoading = true;
            if (this.mode === "update") {
              console.log('update');
              schoolModel
                .update(this.$route.params.id, model)
                .then(() => {
                  this.isLoading = false;
                  this.$store.dispatch(
                    "notification/success",
                    "Data user berhasil diubah."
                  );
                  this.$router.push("/sekolah/" + this.$route.params.id);
                })
                .catch((error) => {
                  this.isLoading = false;
                  this.$store.dispatch("notification/error", error);
                });
            } else {
              console.log('create');
              schoolModel
                .create(model)
                .then((resp) => {
                  this.isLoading = false;
                  // this.resetForm()
                  this.$store.dispatch(
                    "notification/success",
                    "Data user berhasil disimpan."
                  );
                  this.$router.push("/sekolah/" + resp.id);
                })
                .catch((error) => {
                  this.isLoading = false;
                  this.$store.dispatch("notification/error", error);
                });
            }
          })
          .catch(() => {});
      });
    },
  },
};
</script>